import { API_URL, CUSTOMER_ID, getPlatform } from "../config";
import { getFCMToken } from "../utils/firebaseUtils";

// Organisation GET API
export const getOrganisationFromSlug = (slug) => {
  return fetch(`${API_URL}web-organisations/${slug}`, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

// Sign Up API
export const signUp = (bodyData) => {
  return fetch(`${API_URL}web-customer-user`, {
    mode: "cors",
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(bodyData),
  });
};

// Food Category Get API
export const getFoodCategory = (orgID) => {
  return fetch(`${API_URL}web-food-category?organisation=${orgID}`, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

// Restaurant Config get API
export const getRestaurantConfig = (orgID) => {
  return fetch(`${API_URL}web-restaurant-config/${orgID}`, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

// Order creation API
export const createOrder = (bodyData) => {
  const customerId = localStorage.getItem(CUSTOMER_ID);
  return fetch(`${API_URL}web-restaurant-order?customer=${customerId}`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(bodyData),
  });
};

// Current Or Past Order Get API
export const getCurrentOrPastOrders = (isOrderComplete) => {
  const customerId = localStorage.getItem(CUSTOMER_ID);
  return fetch(
    `${API_URL}web-restaurant-order?customer=${customerId}&isOrderComplete=${isOrderComplete}`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

// Current Or Past Order Detail Get API
export const getCurrentOrPastOrderDetail = (orderId) => {
  const customerId = localStorage.getItem(CUSTOMER_ID);
  return fetch(
    `${API_URL}web-restaurant-order/${orderId}?customer=${customerId}`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
};

// Device register Post API
export const registerDevice = async () => {
  const permission = await Notification.requestPermission();
  const fcmToken = await getFCMToken();
  const deviceUuid = crypto.randomUUID();
  const customerId = localStorage.getItem(CUSTOMER_ID);
  const requestData = {
    deviceToken: fcmToken,
    deviceName: "web",
    userID: customerId,
    deviceUUID: deviceUuid,
    deviceType: getPlatform(),
    isSelfServiceEnabled: true
  };
  return fetch(`${API_URL}register-device`, {
    mode: "cors",
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestData),
  });
};

// Retry Payment API
export const retryPayment = (restaurantOrderId, orderId) => {
  return fetch(`${API_URL}klap-order/${restaurantOrderId}`, {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

// payment status GET API
export const getPaymentStatus = (restaurantOrderId) => {
  return fetch(`${API_URL}klap-order/${restaurantOrderId}`, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
